<!-- 登录页面 -->
<template>
  <div class="body-wrap">
    <div class="body-inner-wrap">
      <div class="body-top">
        <router-link tag="h2" class="pointer" to="/">高校企业服务内网</router-link>
        <router-link tag="a" to="/">首页</router-link>
      </div>
      <div class="body-center">
        <div class="body-l-info">
          <h3>更多精彩的进校园商业服务，等您来开启</h3>
          <p>校园活动落地举办</p>
          <p>高端人才实习招聘</p>
          <p>年轻群体商业调研</p>
          <p>......</p>
        </div>
        <div class="body-r-login">
          <div class="ent-inner-wrap">
            <div class="login-top" v-if="loginway == 1">
              <div class="l-top-content">
                <h4>账号登录</h4>
                <div class="l-top-r pointer" @click="handleChangeLoginWay(2)">
                  <div class="l-way-info">手机号登录</div>
                  <span class="icon icon-loginway"></span>
                </div>
              </div>
              <p class="login-info">输入账号直接登录</p>
            </div>
            <div class="login-top" v-if="loginway == 2">
              <div class="l-top-content">
                <h4>手机号登录</h4>
                <div class="l-top-r pointer" @click="handleChangeLoginWay(1)">
                  <div class="l-way-info">用户名登录</div>
                  <span class="icon icon-loginway username"></span>
                </div>
              </div>
              <p class="login-info">输入手机号和验证码登录</p>
            </div>
            <div class="error-info" :class="{hide: errorinfo == ''}">
              <span class="icon icon-info"></span>
              <span>{{errorinfo}}</span>
            </div>
            <div class="login-form">
              <div class="form-input-item" v-if="loginway == 1">
                <input type="text" v-model="username" placeholder="用户名" />
              </div>
              <div class="form-input-item" v-if="loginway == 1 && iseyeclose">
                <input type="password" v-model="password" placeholder="请输入登录密码" />
                <span class="icon icon-eyes close" @click="iseyeclose = !iseyeclose"></span>
              </div>
              <div class="form-input-item" v-if="loginway == 1 && !iseyeclose">
                <input type="text" v-model="password" placeholder="请输入登录密码" />
                <span class="icon icon-eyes open" @click="iseyeclose = !iseyeclose"></span>
              </div>
              <div class="form-input-item" v-if="loginway == 2">
                <input type="text" v-model="phone" maxlength="11" placeholder="手机号码" />
              </div>
              <div class="form-input-item">
                <input type="text" v-model="imgcode" maxlength="6" placeholder="请输入验证码" />
                <img :src="imgCodeUrl" @click="getNewCodeImgKey" alt="换一张" />
              </div>
              <div class="form-input-item" v-if="loginway == 2" maxlength="8">
                <input type="text" v-model="msgcode" placeholder="请输入短信验证码" />
                <getCode
                  :phonenum="phone"
                  :imgcode="imgcode"
                  v-on:handleerror="handleerror"
                  :uuid="randomKey"
                  type="14"
                  ref="code"
                  class="getcode-wrap"
                ></getCode>
              </div>
            </div>
            <div class="login-bottom">
              <!-- <div class="login-bottom-l">
                <span class="icon icon-check-box"></span>
                <span>记住密码</span>
              </div>-->
              <div class="login-bottom-r">
                <router-link class="button-text" tag="a" to="/findpassword">忘记密码？</router-link>
                <router-link class="button-text-active" tag="a" to="/register">开通申请</router-link>
              </div>
            </div>
            <div class="login-button-wrap">
              <button @click="login" @keyup.enter="login">登录</button>
            </div>
          </div>
        </div>
      </div>
      <!-- footer -->
      <my-footer></my-footer>
    </div>
  </div>
</template>

<script>
import vFooter from '@/components/footer/footer.vue'
import getCode from '@/components/getMsgCode/getMsgCode.vue'

export default {
  name: 'login',
  components: {
    'my-footer': vFooter,
    'getCode': getCode
  },
  data () {
    return {
      loginway: 1,
      username: '',
      password: '',
      imgcode: '',
      phone: '',
      msgcode: '',
      errorinfo: '',
      iseyeclose: true,
      randomKey: this.getNewCodeImgKey(),
      imgCodeUrl: this.commonapi + '/captcha?uuid=' + this.randomKey
    }
  },
  created () {
    this.getNewCodeImgKey()
  },
  mounted () {
    document.onkeydown = (e) => {
      if (window.event === undefined) {
        var key = e.keyCode
      } else {
        // eslint-disable-next-line no-redeclare
        var key = window.event.keyCode
      }
      if (key === 13) {
        this.login()
      }
    }
  },
  methods: {
    login () {
      let _ = this
      if (this.loginway === 2 && this.phone === '') {
        this.errorinfo = '请输入手机号'
        return false
      }
      if (this.loginway === 2 && this.$refs.code.pinToken === '') {
        this.errorinfo = '请先获取短信验证码'
        return false
      }
      if (this.loginway === 2 && this.msgcode === '') {
        this.errorinfo = '请输入短信验证码'
        return false
      }
      if (this.loginway === 1 && this.username === '') {
        this.errorinfo = '请输入您的登录用户名'
        return false
      }
      if (this.loginway === 1 && this.password === '') {
        this.errorinfo = '请输入您的登录密码'
        return false
      }
      if (this.loginway === 1 && this.imgcode === '') {
        this.errorinfo = '请输入图片验证码'
        return false
      }
      let data = {}
      let url = ''
      if (this.loginway === 1) {
        data.loginName = this.username
        data.password = this.password
        data.uuid = this.randomKey
        data.code = this.imgcode
        url = '/login/name'
      } else {
        data.mobile = this.phone
        data.smsCode = this.msgcode
        data.pinToken = this.$refs.code.pinToken
        url = '/login/mobile'
      }
      _.$http({
        method: 'POST',
        url: url,
        params: data
      }).then(res => {
        if (res.code === 100) {
          _.errorinfo = ''
          _.$router.push({ path: '/' })
        } else {
          _.errorinfo = res.msg || ''
          _.getNewCodeImgKey()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 生成图片验证码Key
    getNewCodeImgKey () {
      // this.randomKey = Math.ceil(Math.random() * 1000) // 生成一个随机key（防止缓存)
      this.randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      this.imgCodeUrl = this.commonapi + '/captcha?uuid=' + this.randomKey
    },
    handleerror (msg, type) {
      this.errorinfo = msg
      if (type) {
        this.getNewCodeImgKey()
      }
    },
    handleChangeLoginWay (type) {
      this.loginway = type
      this.phone = ''
      this.username = ''
      this.password = ''
      this.msgcode = ''
      this.imgcode = ''
      this.errorinfo = ''
    }
  }
}
</script>

<style scoped>
@import url(login);
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue